/**
 * A dónde mandar a la psicóloga después de loguearse. `ProtectedRoute` redirige a /login
 * guardando la ruta pedida en `location.state.from`; si existe y es una ruta interna segura,
 * se vuelve a ella (ej. el link de una notificación a /profile/metricas/liquidacion?periodo=…).
 * Cualquier otra cosa cae en el inicio.
 */
export const DEFAULT_POST_LOGIN_PATH = '/';

export function getPostLoginPath(state: unknown): string {
  const from = (state as { from?: { pathname?: unknown; search?: unknown; hash?: unknown } } | null)?.from;
  const pathname = from?.pathname;
  if (typeof pathname !== 'string') return DEFAULT_POST_LOGIN_PATH;

  // Solo rutas internas: "/algo", nunca "//host", "/\host" ni esquemas externos; y nunca volver a
  // /login (loop).
  if (!pathname.startsWith('/') || pathname.startsWith('//') || pathname.includes('\\')) {
    return DEFAULT_POST_LOGIN_PATH;
  }
  if (pathname === '/login' || pathname.startsWith('/login/')) return DEFAULT_POST_LOGIN_PATH;

  const search = typeof from?.search === 'string' ? from.search : '';
  const hash = typeof from?.hash === 'string' ? from.hash : '';
  return `${pathname}${search}${hash}`;
}
